import React from 'react'
import StateWrapper from './StateWrapper'

const EmptyState = props => <StateWrapper {...props} icon='Cactus' />

export default EmptyState
